module.exports = __webpack_public_path__ + "static/media/bank_icon.25440d87.svg";